import { defineComponent as y, ref as n, computed as B, onBeforeUnmount as C } from "vue";
import { uniqueId as h } from "lodash-es";
import { getConfig as M } from "./td-longtail-vue-components2.js";
import { addFocusTrap as b } from "./td-longtail-vue-components92.js";
import p from "./td-longtail-vue-components86.js";
import w from "./td-longtail-vue-components6.js";
import R from "./td-longtail-vue-components3.js";
const L = /* @__PURE__ */ y({
  __name: "base-dialog",
  props: {
    customClass: { default: void 0 },
    customContainerClass: { default: void 0 },
    dataTealiumRel: { default: void 0 },
    headingText: { default: void 0 },
    ariaLabel: { default: void 0 },
    closeOnBackdrop: { type: Boolean },
    closeAutofocus: { type: Boolean },
    isModal: { type: Boolean },
    disableFocusTrap: { type: Boolean }
  },
  emits: ["onCloseModal"],
  setup(v, { expose: T, emit: c }) {
    const e = v, g = n(h()), o = n(null), u = n(!1), a = n(null), { tealium: l } = M(), s = B(() => e.isModal ? "modal" : "flyout");
    function t() {
      o.value?.close();
    }
    const f = (d) => {
      o.value && d.key === "Escape" && t();
    }, r = () => {
      if (e.dataTealiumRel) return p(e.dataTealiumRel);
      const d = o.value?.querySelector(".base-dialog__header");
      return p(d?.innerText || "");
    }, i = b(f);
    function m() {
      u.value = !0, a.value && clearTimeout(a.value), a.value = setTimeout(() => {
        e.isModal ? o.value?.showModal() : o.value?.show(), e.disableFocusTrap || i.add(o), l && l.link({ wt_link_id: `content.${s.value}.${r()}.open` });
      }, 1);
    }
    function _() {
      i.remove(), a.value && clearTimeout(a.value), c("onCloseModal"), l && l.link({ wt_link_id: `content.${s.value}.${r()}.close` }), a.value = setTimeout(() => {
        u.value = !1;
      }, 126);
    }
    function k() {
      e.closeOnBackdrop && t();
    }
    return C(() => {
      i.remove();
    }), T({ openDialog: m, closeDialog: t }), { __sfc: !0, props: e, uid: g, emits: c, dialogElement: o, isDialogOpen: u, timeout: a, tealium: l, tealiumName: s, closeDialog: t, handleKeyEvent: f, getTealiumRel: r, focusTrap: i, openDialog: m, closeNative: _, handleBackdropClick: k, Heading: w, LinkButton: R };
  }
});
export {
  L as default
};
